import React, {useEffect, useState} from 'react';
import BackSubheader from 'src/components/elements/BackSubheader';
import Localized from 'src/constants/AppStrings';
import {StyleSheet} from 'react-native';
import {useDispatch} from 'react-redux';
import AVTextInput from 'src/components/elements/AVTextInput';
import Styles from 'src/components/Styles';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import {
  fetchAccountBalances,
  scanGiftCard,
} from 'src/redux/slices/accountSlice';
import ActionsFactory from 'src/actions/ActionsFactory';
import AccountStore from 'src/stores/AccountStore';
import FirebaseAnalytic from '../../../nativeModules/FirebaseAnalytic';
import {useAppSelector} from 'src/redux/hooks';
import NavActions from 'src/actions/NavActions';
import AppRoutes from 'src/AppRoutes';

function AddEGiftCardManual() {
  const dispatch = useDispatch();
  const [code, setCode] = useState<string>('');
  const account = useAppSelector((s) => s.account?.account);
  useEffect(() => {
    dispatch(fetchAccountBalances(account?.id));
  }, []);
  return (
    <BackSubheader title={Localized.Labels.add_card}>
      <AVTextInput
        placeholder={Localized.Labels.enter_egift_card_number}
        style={styles.textInput}
        placeholderTextColor={Styles.lightGray}
        onChangeText={setCode}
        value={code}
      />
      <RoundedButton
        text={Localized.Buttons.add_card}
        buttonType={ButtonType.action}
        onPress={async () => {
          FirebaseAnalytic.trackEvent(
            'Localized.Buttons.add_card',
            'AddEGiftCardManual',
            {
              code,
            },
          );
          const data = await dispatch(
            scanGiftCard({
              code,
              callback: () =>
                ActionsFactory.getAccountActions().reloadConsumerData({
                  accountId: AccountStore.getAccountId(),
                  accountBalanceId: AccountStore.getAccountBalanceId(),
                  email: AccountStore.getEmail(),
                  userInitiated: true,
                }),
            }),
          );
          if (data['payload'] && data['payload']['isSuccess'] == false) {
            setCode('');
          }
          if (data['payload'] && data['payload']['isSmaRestrict'] == true) {
            NavActions.navigate(AppRoutes.ServerErrorDialog, {
              errorTitle: Localized.Errors.egift_card_message,
              errorDesc: Localized.Errors.egift_card_desc,
            });
            return;
          }
        }}
        disabled={code === ''}
      />
    </BackSubheader>
  );
}

const styles = StyleSheet.create({
  addBtnView: {
    flex: 1,
    justifyContent: 'flex-end',
    marginBottom: Styles.Spacing.m3,
    marginHorizontal: Styles.Spacing.m3,
  },
  textInput: {
    marginHorizontal: Styles.Spacing.m3,
    fontWeight: 'bold',
  },
});

export default AddEGiftCardManual;
